<div class="flex flex-col flex-auto min-w-0">

  <!-- Main -->
  <div class="flex-auto">

    <!-- CONTENT GOES HERE -->
    <div class="h-full max-content-h">
      <div class="drk-page-wrapper flex flex-col lg:flex-row gap-4 h-full p-4">

        <!-- Main Chat Area -->
        <div
          class="flex flex-col h-full bg-white rounded-md shadow-lg border border-gray-200 overflow-hidden font-sans flex-1 min-w-0">

          <!-- Header -->
          <div class="px-6 py-4 flex items-center justify-between text-white"
            style="background-color: var(--custom-color, #000);">
            <div class="flex items-center space-x-3">
              <div class="w-10 h-10 bg-white rounded-full flex items-center justify-center">
                <svg class="w-6 h-6" style="color: var(--custom-color, #000);" fill="none" stroke="currentColor"
                  viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z">
                  </path>
                </svg>
              </div>
              <div>
                <h3 class="font-bold text-lg leading-tight">DrakeBrain</h3>
                <p class="text-white/80 text-xs">AI Assistant</p>
              </div>
            </div>

            <div class="flex items-center space-x-3">
              <span *ngIf="saveFeedback" class="text-[11px] text-white/90">{{ saveFeedback }}</span>
              <!-- Nuova Chat Button -->
              <button (click)="startNewChat()"
                class="bg-white/15 text-white border border-white/50 text-xs font-bold px-3 py-1.5 rounded-md hover:bg-white/25 transition-colors shadow-sm flex items-center">
                <svg class="w-3.5 h-3.5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
                </svg>
                Nuova chat
              </button>
              <!-- Share is available only for an owned saved analysis. -->
              <button *ngIf="selectedAnalysisId && !isReadOnlyAnalysis" (click)="openShareModal(selectedAnalysisId)"
                class="bg-white/15 text-white border border-white/50 text-xs font-bold px-3 py-1.5 rounded-md hover:bg-white/25 transition-colors shadow-sm flex items-center">
                <svg class="w-3.5 h-3.5 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z">
                  </path>
                </svg>
                Condividi
              </button>
              <!-- Save Button -->
              <button *ngIf="!isReadOnlyAnalysis && hasAnySelection()" (click)="saveSelectedToDb()"
                class="bg-white text-[var(--custom-color)] text-xs font-bold px-3 py-1.5 rounded-md hover:bg-gray-100 transition-colors shadow-sm flex items-center">
                <svg class="w-3.5 h-3.5 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4">
                  </path>
                </svg>
                Salva Selezionati
              </button>

              <span *ngIf="isLoading" class="flex h-3 w-3 relative">
                <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
                <span class="relative inline-flex rounded-full h-3 w-3 bg-white"></span>
              </span>
              <span *ngIf="!isLoading" class="h-3 w-3 rounded-full bg-green-400"></span>
            </div>
          </div>

          <!-- Chat Area -->
          <div #chatContainer (scroll)="onScroll()"
            class="flex-1 p-6 overflow-y-auto bg-gray-50 flex flex-col space-y-4 h-[40rem]">
            <div *ngFor="let msg of messages" class="flex w-full"
              [ngClass]="msg.role === 'user' ? 'justify-end' : 'justify-start'">

              <!-- Assistant Message -->
              <div *ngIf="msg.role === 'assistant'" class="flex space-x-3 max-w-[85%] w-full">
                <div class="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center border mt-1"
                  style="border-color: var(--custom-color, #000); background-color: transparent;">
                  <svg class="w-4 h-4" style="color: var(--custom-color, #000);" fill="none" stroke="currentColor"
                    viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z">
                    </path>
                  </svg>
                </div>

                <div class="flex flex-col space-y-2 w-full">

                  <!-- Select All for this message -->
                  <div
                    *ngIf="!isReadOnlyAnalysis && (msg.content || msg.sqlQuery || msg.chartOptions || msg.tableData) && msg.status === 'COMPLETED'"
                    class="flex justify-end mb-1">
                    <button (click)="toggleAll(msg)"
                      class="group flex items-center space-x-1.5 px-3 py-1.5 rounded-full transition-all text-[10px] uppercase tracking-wider font-bold shadow-sm border focus:outline-none"
                      [ngClass]="isAllSelected(msg) ? 'bg-gray-800 border-gray-800 text-white hover:bg-gray-700 hover:border-gray-700 hover:-translate-y-0.5' : 'bg-white border-gray-200 text-gray-500 hover:border-gray-300 hover:bg-gray-50 hover:text-gray-700 hover:-translate-y-0.5'">
                      <svg class="w-3.5 h-3.5 transition-transform group-hover:scale-110" fill="none"
                        stroke="currentColor" viewBox="0 0 24 24">
                        <path *ngIf="!isAllSelected(msg)" stroke-linecap="round" stroke-linejoin="round"
                          stroke-width="2.5" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                        <path *ngIf="isAllSelected(msg)" stroke-linecap="round" stroke-linejoin="round"
                          stroke-width="2.5" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z">
                        </path>
                      </svg>
                      <span>{{ isAllSelected(msg) ? 'Deseleziona tutto' : 'Seleziona tutto' }}</span>
                    </button>
                  </div>

                  <!-- Thoughts (Collapsible) -->
                  <div *ngIf="msg.thoughts && msg.thoughts.length > 0" class="relative group w-full">
                    <div class="absolute top-1.5 right-2 z-10 transition-opacity"
                      [ngClass]="msg.selected?.thoughts ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'">
                      <button *ngIf="msg.selected && !isReadOnlyAnalysis"
                        (click)="msg.selected.thoughts = !msg.selected.thoughts"
                        class="w-6 h-6 rounded-full flex items-center justify-center transition-all shadow-sm border focus:outline-none"
                        [ngClass]="msg.selected.thoughts ? 'bg-[var(--custom-color)] border-[var(--custom-color)] text-white scale-110' : 'bg-white border-gray-300 text-transparent hover:border-[var(--custom-light)]'"
                        title="Seleziona ragionamento AI">
                        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7">
                          </path>
                        </svg>
                      </button>
                    </div>
                    <details
                      class="text-xs text-gray-500 bg-gray-100 rounded-lg px-3 py-2 cursor-pointer w-full shadow-sm border border-gray-200 transition-all pr-10"
                      [class.ring-2]="msg.selected?.thoughts"
                      [class.ring-[var(--custom-color)]]="msg.selected?.thoughts"
                      [class.ring-offset-2]="msg.selected?.thoughts">
                      <summary class="font-medium hover:text-gray-700 outline-none">🧠 Come ci sono arrivato?</summary>
                      <ul class="mt-2 space-y-1 pl-2 border-l-2" style="border-color: var(--custom-color, #000);">
                        <li *ngFor="let t of msg.thoughts" class="whitespace-pre-wrap">{{ t }}</li>
                      </ul>
                    </details>
                  </div>

                  <!-- SQL Query (Collapsible) -->
                  <div *ngIf="msg.sqlQuery" class="relative group w-full mt-2">
                    <div class="absolute top-1.5 right-2 z-10 transition-opacity"
                      [ngClass]="msg.selected?.sqlQuery ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'">
                      <button *ngIf="msg.selected && !isReadOnlyAnalysis"
                        (click)="msg.selected.sqlQuery = !msg.selected.sqlQuery"
                        class="w-6 h-6 rounded-full flex items-center justify-center transition-all shadow-sm border focus:outline-none"
                        [ngClass]="msg.selected.sqlQuery ? 'bg-[var(--custom-color)] border-[var(--custom-color)] text-white scale-110' : 'bg-white border-gray-300 text-transparent hover:border-[var(--custom-light)]'"
                        title="Seleziona query SQL">
                        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7">
                          </path>
                        </svg>
                      </button>
                    </div>
                    <details
                      class="text-xs text-gray-500 bg-gray-100 rounded-lg px-3 py-2 cursor-pointer w-full shadow-sm border border-gray-200 max-w-full transition-all"
                      [class.ring-2]="msg.selected?.sqlQuery"
                      [class.ring-[var(--custom-color)]]="msg.selected?.sqlQuery"
                      [class.ring-offset-2]="msg.selected?.sqlQuery">
                      <summary class="font-medium hover:text-gray-700 outline-none">🔍 Query SQL Eseguita</summary>
                      <div
                        class="mt-2 bg-gray-800 text-gray-100 rounded-lg p-3 text-xs overflow-x-auto relative shadow-inner max-w-full cursor-text">
                        <div
                          class="absolute top-1 right-2 text-gray-400 text-[10px] uppercase font-bold tracking-wider">
                          SQL</div>
                        <pre class="m-0"><code class="whitespace-pre-wrap">{{ msg.sqlQuery }}</code></pre>
                      </div>
                    </details>
                  </div>

                  <!-- Markdown Text -->
                  <div *ngIf="msg.content" class="relative group w-full">
                    <div class="absolute top-1.5 right-2 z-10 transition-opacity"
                      [ngClass]="msg.selected?.content ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'">
                      <button *ngIf="msg.selected && !isReadOnlyAnalysis"
                        (click)="msg.selected.content = !msg.selected.content"
                        class="w-6 h-6 rounded-full flex items-center justify-center transition-all shadow-sm border focus:outline-none"
                        [ngClass]="msg.selected.content ? 'bg-[var(--custom-color)] border-[var(--custom-color)] text-white scale-110' : 'bg-white border-gray-300 text-transparent hover:border-[var(--custom-light)]'"
                        title="Seleziona testo">
                        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7">
                          </path>
                        </svg>
                      </button>
                    </div>
                    <div
                      class="bg-white px-4 py-3 rounded-2xl rounded-tl-none shadow-sm text-gray-800 text-sm prose prose-sm max-w-none transition-all"
                      [class.ring-2]="msg.selected?.content" [class.ring-[var(--custom-color)]]="msg.selected?.content"
                      [class.ring-offset-2]="msg.selected?.content" [innerHTML]="msg.content">
                    </div>
                  </div>

                  <!-- Status Indicator -->
                  <div *ngIf="!msg.content && isLoading && msg === messages[messages.length-1]"
                    class="bg-white px-4 py-3 rounded-2xl rounded-tl-none shadow-sm flex items-center space-x-3 w-fit">
                    <div class="flex space-x-1">
                      <div class="w-1.5 h-1.5 rounded-full animate-bounce"
                        style="background-color: var(--custom-color, #60a5fa)"></div>
                      <div class="w-1.5 h-1.5 rounded-full animate-bounce"
                        style="background-color: var(--custom-color, #60a5fa); animation-delay: 0.2s"></div>
                      <div class="w-1.5 h-1.5 rounded-full animate-bounce"
                        style="background-color: var(--custom-color, #60a5fa); animation-delay: 0.4s"></div>
                    </div>
                    <span class="text-xs text-gray-500 italic">{{ getStatusDescription(msg.status) }}</span>
                  </div>

                  <!-- Chart -->
                  <div *ngIf="msg.chartOptions" class="relative group w-full">
                    <div class="absolute top-1.5 right-2 z-10 transition-opacity"
                      [ngClass]="msg.selected?.chart ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'">
                      <button *ngIf="msg.selected && !isReadOnlyAnalysis"
                        (click)="msg.selected.chart = !msg.selected.chart"
                        class="w-6 h-6 rounded-full flex items-center justify-center transition-all shadow-sm border focus:outline-none"
                        [ngClass]="msg.selected.chart ? 'bg-[var(--custom-color)] border-[var(--custom-color)] text-white scale-110' : 'bg-white border-gray-300 text-transparent hover:border-[var(--custom-light)]'"
                        title="Seleziona grafico">
                        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7">
                          </path>
                        </svg>
                      </button>
                    </div>
                    <div
                      class="bg-white rounded-2xl rounded-tl-none shadow-sm border border-gray-100 p-4 w-full transition-all"
                      [class.ring-2]="msg.selected?.chart" [class.ring-[var(--custom-color)]]="msg.selected?.chart"
                      [class.ring-offset-2]="msg.selected?.chart">
                      <div *ngIf="msg.chartOptions.loading"
                        class="flex flex-col items-center justify-center h-48 text-gray-400 space-y-2">
                        <svg class="animate-spin h-6 w-6" style="color: var(--custom-color, #000);"
                          xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4">
                          </circle>
                          <path class="opacity-75" fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                          </path>
                        </svg>
                        <span class="text-xs">Generazione grafico...</span>
                      </div>
                      <apx-chart *ngIf="!msg.chartOptions.loading" class="w-full block"
                        [series]="msg.chartOptions.series" [chart]="msg.chartOptions.chart"
                        [dataLabels]="msg.chartOptions.dataLabels" [plotOptions]="msg.chartOptions.plotOptions"
                        [xaxis]="msg.chartOptions.xaxis" [yaxis]="msg.chartOptions.yaxis"
                        [theme]="msg.chartOptions.theme"></apx-chart>
                    </div>
                  </div>

                  <!-- Data Table -->
                  <div *ngIf="msg.tableData" class="relative group mt-2 w-full">
                    <div class="absolute top-1.5 right-2 z-10 transition-opacity"
                      [ngClass]="msg.selected?.table ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'">
                      <button *ngIf="msg.selected && !isReadOnlyAnalysis"
                        (click)="msg.selected.table = !msg.selected.table"
                        class="w-6 h-6 rounded-full flex items-center justify-center transition-all shadow-sm border focus:outline-none"
                        [ngClass]="msg.selected.table ? 'bg-[var(--custom-color)] border-[var(--custom-color)] text-white scale-110' : 'bg-white border-gray-300 text-transparent hover:border-[var(--custom-light)]'"
                        title="Seleziona tabella">
                        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7">
                          </path>
                        </svg>
                      </button>
                    </div>
                    <div
                      class="bg-white rounded-2xl rounded-tl-none shadow-sm border border-gray-100 p-4 w-full transition-all"
                      [class.ring-2]="msg.selected?.table" [class.ring-[var(--custom-color)]]="msg.selected?.table"
                      [class.ring-offset-2]="msg.selected?.table">
                      <div *ngIf="msg.tableData.loading"
                        class="flex flex-col items-center justify-center h-24 text-gray-400 space-y-2">
                        <svg class="animate-spin h-6 w-6" style="color: var(--custom-color, #000);"
                          xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4">
                          </circle>
                          <path class="opacity-75" fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                          </path>
                        </svg>
                        <span class="text-xs">Recupero dati in corso...</span>
                      </div>
                      <div *ngIf="!msg.tableData.loading" class="overflow-x-auto w-full">
                        <table class="min-w-full divide-y divide-gray-200 text-xs">
                          <thead class="bg-gray-50">
                            <tr>
                              <th *ngFor="let col of msg.tableData.columns"
                                class="px-4 py-2 text-left text-[10px] font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">
                                {{ col.name }}
                              </th>
                            </tr>
                          </thead>
                          <tbody class="bg-white divide-y divide-gray-200">
                            <tr *ngFor="let row of msg.tableData.paginatedRows"
                              class="hover:bg-gray-50 transition-colors">
                              <td *ngFor="let cell of row" class="px-4 py-2 whitespace-nowrap text-gray-700">
                                {{ cell }}
                              </td>
                            </tr>
                            <tr *ngIf="msg.tableData.rows.length === 0">
                              <td [attr.colspan]="msg.tableData.columns.length"
                                class="px-4 py-4 text-center text-gray-500 italic">
                                La query non ha restituito risultati.
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <!-- Pagination Controls -->
                      <div *ngIf="!msg.tableData.loading && msg.tableData.rows.length > (msg.tableData.pageSize || 15)"
                        class="px-4 py-3 border-t border-gray-200 flex items-center justify-between sm:px-6 bg-gray-50 rounded-b-lg">
                        <div class="flex-1 flex items-center justify-between">
                          <div>
                            <p class="text-[10px] text-gray-700 m-0">
                              Pagina <span class="font-medium">{{ msg.tableData.currentPage }}</span> di <span
                                class="font-medium">{{ getTableMaxPage(msg) }}</span> ({{msg.tableData.rows.length}}
                              righe totali)
                            </p>
                          </div>
                          <div>
                            <nav class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
                              aria-label="Pagination">
                              <button (click)="changeTablePage(msg, -1)" [disabled]="msg.tableData.currentPage === 1"
                                class="relative inline-flex items-center px-2 py-1.5 rounded-l-md border border-gray-300 bg-white text-[10px] font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50">
                                Precedente
                              </button>
                              <button (click)="changeTablePage(msg, 1)"
                                [disabled]="msg.tableData.currentPage === getTableMaxPage(msg)"
                                class="relative inline-flex items-center px-2 py-1.5 rounded-r-md border border-gray-300 bg-white text-[10px] font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50">
                                Successiva
                              </button>
                            </nav>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Suggestions -->
                  <div *ngIf="msg.suggestions && msg.suggestions.length > 0" class="flex flex-wrap gap-2 mt-2">
                    <button *ngFor="let sug of msg.suggestions" (click)="sendMessage(sug)"
                      [disabled]="isReadOnlyAnalysis"
                      class="px-3 py-2 bg-gray-50 border border-gray-200 rounded-full text-xs font-medium hover:bg-gray-100 hover:shadow-sm hover:-translate-y-0.5 transition-all text-left"
                      style="color: var(--custom-color, #000);">
                      💡 {{ sug }}
                    </button>
                  </div>

                </div>
              </div>

              <!-- User Message -->
              <div *ngIf="msg.role === 'user'" class="flex space-x-3 max-w-[80%] flex-row-reverse space-x-reverse">
                <div class="flex-shrink-0 w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center mt-1">
                  <svg class="w-4 h-4 text-gray-500" fill="currentColor" viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                      clip-rule="evenodd"></path>
                  </svg>
                </div>
                <div class="px-4 py-3 rounded-2xl rounded-tr-none shadow-sm text-white text-sm whitespace-pre-wrap"
                  style="background-color: var(--custom-color, #000);">
                  {{ msg.content }}
                </div>
              </div>

            </div>
          </div>

          <!-- Input Area -->
          <div class="bg-white px-4 py-4 border-t border-gray-200">
            <div class="relative flex items-center w-full">
              <input type="text" [(ngModel)]="userInput" (keyup.enter)="sendMessage()"
                [disabled]="isReadOnlyAnalysis || isLoading || !config"
                [placeholder]="isReadOnlyAnalysis ? 'Analisi condivisa in sola lettura' : 'Fai una domanda a DrakeBrain...'"
                class="w-full bg-gray-100 border-transparent rounded-full px-5 py-3 pr-12 focus:ring-2 focus:bg-white focus:border-transparent text-sm transition-colors duration-200">
              <button (click)="sendMessage()" [hidden]="isReadOnlyAnalysis"
                [disabled]="isReadOnlyAnalysis || !userInput.trim() || isLoading || !config"
                class="absolute right-2 p-2 text-white rounded-full hover:opacity-90 transition-opacity duration-200 disabled:opacity-50 flex items-center justify-center"
                style="background-color: var(--custom-color, #000);">
                <svg class="w-4 h-4 transform rotate-90" fill="currentColor" viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z">
                  </path>
                </svg>
              </button>
            </div>
            <div class="text-center mt-2">
              <span class="text-[10px] text-gray-400">Le risposte sono generate da AI e possono contenere
                inesattezze.</span>
            </div>
          </div>

        </div>

        <!-- Pannello di Destra (Analisi Salvate e Condivise) -->
        <div
          class="flex flex-col h-full bg-white rounded-md shadow-lg border border-gray-200 overflow-hidden font-sans w-full lg:w-80 shrink-0">
          <!-- Tabs Header -->
          <div class="flex border-b border-gray-200 bg-gray-50">
            <button class="flex-1 py-3.5 text-sm font-semibold transition-colors focus:outline-none"
              [ngClass]="activeTab === 'saved' ? 'border-b-2 border-[var(--custom-color)] text-[var(--custom-color)] bg-white' : 'text-gray-500 hover:text-gray-700'"
              (click)="activeTab = 'saved'">
              Le tue Analisi
            </button>
            <button class="flex-1 py-3.5 text-sm font-semibold transition-colors focus:outline-none"
              [ngClass]="activeTab === 'shared' ? 'border-b-2 border-[var(--custom-color)] text-[var(--custom-color)] bg-white' : 'text-gray-500 hover:text-gray-700'"
              (click)="activeTab = 'shared'">
              Condivise
            </button>
          </div>

          <!-- Tabs Content -->
          <div class="flex-1 overflow-y-auto p-3 custom-scrollbar space-y-3 bg-gray-50/30">

            <!-- Tab: Saved -->
            <ng-container *ngIf="activeTab === 'saved'">
              <div *ngIf="savedAnalyses.length === 0" class="text-center py-10 text-gray-400 text-sm">
                Nessuna analisi salvata.
              </div>
              <div *ngFor="let item of savedAnalyses" (click)="loadAnalysis(item, false)"
                class="p-3.5 rounded-xl border shadow-sm transition-shadow cursor-pointer group"
                [style.backgroundColor]="selectedAnalysisId === getAnalysisId(item) ? 'var(--custom-color)' : ''"
                [ngClass]="selectedAnalysisId === getAnalysisId(item) ? 'border-[var(--custom-color)]' : 'bg-white border-gray-100 hover:shadow'">
                <div class="flex items-start justify-between">
                  <h4 class="text-sm font-medium line-clamp-2 leading-snug transition-colors"
                    [ngClass]="selectedAnalysisId === getAnalysisId(item) ? 'text-white' : 'text-gray-800 group-hover:text-[var(--custom-color)]'">
                    {{ item.OriginalPrompt || 'Analisi senza titolo' }}
                  </h4>
                </div>
                <div class="mt-2.5 flex items-center justify-between text-xs"
                  [ngClass]="selectedAnalysisId === getAnalysisId(item) ? 'text-white/80' : 'text-gray-500'">
                  <span class="flex items-center">
                    <svg class="w-3.5 h-3.5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    {{ parseDate(item.LastEditDate) | date:'dd/MM/yy HH:mm' }}
                  </span>
                </div>
              </div>
            </ng-container>

            <!-- Tab: Shared -->
            <ng-container *ngIf="activeTab === 'shared'">
              <div *ngIf="sharedAnalyses.length === 0" class="text-center py-10 text-gray-400 text-sm">
                Nessuna analisi condivisa.
              </div>
              <div *ngFor="let item of sharedAnalyses" (click)="loadAnalysis(item, true)"
                class="p-3.5 rounded-xl border shadow-sm transition-shadow cursor-pointer group"
                [style.backgroundColor]="selectedAnalysisId === getAnalysisId(item) ? 'var(--custom-color)' : ''"
                [ngClass]="selectedAnalysisId === getAnalysisId(item) ? 'border-[var(--custom-color)]' : 'bg-white border-gray-100 hover:shadow'">
                <div class="flex items-start justify-between">
                  <h4 class="text-sm font-medium line-clamp-2 leading-snug transition-colors"
                    [ngClass]="selectedAnalysisId === getAnalysisId(item) ? 'text-white' : 'text-gray-800 group-hover:text-[var(--custom-color)]'">
                    <!-- Se abbiamo un ID o una descrizione -->
                    {{ item.AnalysisId.text || 'Sconosciuto' }}
                  </h4>
                </div>
                <div class="mt-2.5 flex flex-col gap-1.5 text-xs"
                  [ngClass]="selectedAnalysisId === getAnalysisId(item) ? 'text-white/80' : 'text-gray-500'">

                  <!-- Condivisi da me -->
                  <span *ngIf="item.SentTo && item.SentTo.length > 0" class="flex items-center font-medium"
                    [ngClass]="selectedAnalysisId === getAnalysisId(item) ? 'text-white' : 'text-[var(--custom-color)]'">
                    <svg class="w-3.5 h-3.5 mr-1.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z">
                      </path>
                    </svg>
                    <span class="truncate" [title]="item.SentTo.join(', ')">Condiviso con: {{ item.SentTo.join(', ')
                      }}</span>
                  </span>

                  <!-- Condivisi con me -->
                  <span *ngIf="item.ReceivedFrom && item.ReceivedFrom.length > 0" class="flex items-center font-medium"
                    [ngClass]="selectedAnalysisId === getAnalysisId(item) ? 'text-white' : 'text-green-600'">
                    <svg class="w-3.5 h-3.5 mr-1.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4">
                      </path>
                    </svg>
                    <span class="truncate">Ricevuto da: {{ item.ReceivedFrom.join(', ') }}</span>
                  </span>

                  <span class="flex items-center">
                    <svg class="w-3.5 h-3.5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    {{ parseDate(item.LastEditDate) | date:'dd/MM/yy HH:mm' }}
                  </span>
                </div>
              </div>
            </ng-container>

          </div>
        </div>
      </div> <!-- Fine drk-page-wrapper -->
    </div>
  </div>
</div>

<!-- Modal Condivisione Utenti -->
<div *ngIf="showShareModal"
  class="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-gray-900/40 backdrop-blur-sm transition-opacity">
  <div
    class="bg-white rounded-2xl shadow-2xl w-full max-w-md flex flex-col max-h-[85vh] border border-gray-100 overflow-hidden transform transition-all">
    <!-- Header -->
    <div class="px-6 py-4 border-b border-gray-100 bg-gray-50 flex justify-between items-center">
      <h3 class="text-lg font-semibold text-gray-800">Condividi Analisi</h3>
      <button (click)="cancelShare()"
        class="text-gray-400 hover:text-gray-600 hover:bg-gray-100 p-1.5 rounded-full transition-colors focus:outline-none">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <!-- Body -->
    <div class="p-6 flex flex-col flex-1 overflow-hidden">
      <p class="text-sm text-gray-500 mb-3">Seleziona gli utenti con cui vuoi condividere i dati salvati:</p>

      <!-- Search Input -->
      <div class="relative mb-4 shrink-0">
        <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none text-gray-400">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
          </svg>
        </div>
        <input type="text" [(ngModel)]="userSearchQuery" placeholder="Cerca per nome, cognome o email..."
          class="w-full bg-gray-50 border border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-[var(--custom-color)] focus:border-[var(--custom-color)] block pl-10 p-2.5 outline-none transition-colors">
      </div>

      <div class="space-y-2.5 overflow-y-auto custom-scrollbar pr-1 flex-1">
        <div *ngIf="filteredUsers.length === 0" class="text-center py-8 text-gray-400 text-sm">
          Nessun utente trovato.
        </div>
        <div *ngFor="let user of filteredUsers" (click)="toggleUserSelection(user._id)"
          class="flex items-center p-3 rounded-xl border cursor-pointer transition-all hover:border-[var(--custom-light)] group"
          [ngClass]="isUserSelected(user._id) ? 'border-[var(--custom-color)] bg-[var(--custom-transparent)] shadow-sm' : 'border-gray-200 bg-white'">

          <div
            class="w-10 h-10 rounded-full flex items-center justify-center text-sm font-semibold mr-3 transition-colors border"
            [ngClass]="isUserSelected(user._id) ? 'border-transparent' : 'border-[var(--custom-light)]'"
            [style.backgroundColor]="isUserSelected(user._id) ? 'var(--custom-color)' : 'var(--custom-transparent)'"
            [style.color]="isUserSelected(user._id) ? 'white' : 'var(--custom-color)'">
            {{ user.FirstName ? user.FirstName.charAt(0).toUpperCase() : '' }}{{ user.LastName ?
            user.LastName.charAt(0).toUpperCase() : '' }}
          </div>

          <div class="flex-1 min-w-0">
            <p class="text-sm font-medium text-gray-900 truncate">{{ user.FirstName }} {{ user.LastName }}</p>
            <p class="text-xs text-gray-500 truncate">{{ user.Email }}</p>
          </div>

          <div class="w-5 h-5 rounded-full border flex items-center justify-center transition-colors ml-3 shadow-sm"
            [ngClass]="isUserSelected(user._id) ? 'border-[var(--custom-color)] bg-[var(--custom-color)] text-white scale-110' : 'border-gray-300 bg-white text-transparent'">
            <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="px-6 py-4 border-t border-gray-100 bg-gray-50 flex justify-end space-x-3">
      <button (click)="cancelShare()"
        class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors shadow-sm focus:outline-none">
        Annulla
      </button>
      <button (click)="confirmShare()" [disabled]="selectedUserIds.length === 0"
        class="px-5 py-2 text-sm font-medium text-white rounded-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed shadow-sm hover:shadow-md focus:outline-none"
        style="background-color: var(--custom-color, #2563eb);">
        Condividi {{ selectedUserIds.length > 0 ? '(' + selectedUserIds.length + ')' : '' }}
      </button>
    </div>
  </div>
</div>